(function () {
  function randomBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function init(el) {
    if (el.dataset.lvInitialized === 'true') return;
    el.dataset.lvInitialized = 'true';

    var min = parseInt(el.dataset.min, 10);
    var max = parseInt(el.dataset.max, 10);
    if (isNaN(min) || isNaN(max)) return;

    var countEl = el.querySelector('.sc-live-viewers-count');
    if (!countEl) return;

    var timeoutId = null;

    function tick() {
      countEl.textContent = randomBetween(min, max);
      timeoutId = setTimeout(tick, randomBetween(5000, 10000));
    }

    countEl.textContent = randomBetween(min, max);
    timeoutId = setTimeout(tick, randomBetween(5000, 10000));

    el.lvDestroy = function () {
      clearTimeout(timeoutId);
      el.dataset.lvInitialized = 'false';
    };
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.sc-live-viewers').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    var el = evt.target.querySelector('.sc-live-viewers');
    if (el && el.lvDestroy) el.lvDestroy();
  });
})();
